import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Translation } from 'react-i18next';

import CircularProgress from '@material-ui/core/CircularProgress';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { withStyles } from '@material-ui/core/styles';
import Dialog from 'components/DialogWrapper/DialogWrapper';

//import ClockOutDialog from 'components/ClockOutDialog/ClockOutDialog';
import SideBadge from 'components/SideBadge/SideBadge';
import ProjectItem from './components/ProjectItem';
import RecordItem from './components/RecordItem';
import TimerContent from './components/TimerContent';
import { mdiTimerOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { connect } from 'react-redux';
import { selectLatestProjectsClockedInTo } from 'store/projects/selectors/projectsRecords.selectors';
import {
  selectIsClockedInRecordsLoading,
  selectPersonalClockedInWorkRecords,
} from 'store/records/selectors/records.selectors';
import { clockInRecord } from 'store/records/thunks/clockInRecord.thunk';
import { openClockOutRecordDialog } from 'store/records/thunks/openClockOutRecordDialog';
import { openEditRecordDialog } from 'store/records/thunks/openEditRecordDialog.thunk';

const mapStateToProps = (state) => ({
  user: state.root.user,
  inRecords: selectPersonalClockedInWorkRecords(state),
  inRecordsLoading: selectIsClockedInRecordsLoading(state),
  lastProjects: selectLatestProjectsClockedInTo(state),
});

const mapDispatchToProps = (dispatch) => {
  return {
    openRecordDialog: (record) => dispatch(openEditRecordDialog(record.id)),
    openClockOutDialog: (projectId) =>
      dispatch(openClockOutRecordDialog(projectId)),
    clockInRecord: ({ projectId, allowClockInWithoutLocation }) =>
      dispatch(clockInRecord({ projectId, allowClockInWithoutLocation })),
  };
};

const styles = (theme) => ({
  root: {
    display: 'inherit',
    // '&:hover': {
    //   color: 'hsla(195,75%,25%,1)',
    //   [theme.breakpoints.up('sm')]: {
    //     color: 'hsla(195,75%,25%,0.75)',
    //   },
    // },
  },
  rootOpen: {
    color: 'hsla(195,75%,25%,1)',
    [theme.breakpoints.up('sm')]: {
      color: 'hsla(195,75%,25%,0.75)',
    },
  },
  iconButton: {
    height: 40,
    padding: 0,
    width: 40,
    [theme.breakpoints.up('sm')]: {
      margin: '0 4px',
    },
  },
  listTitle: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(2),
    padding: '8px',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" {...props} ref={ref} />
));
Transition.displayName = 'Transition';

class TimerButton extends Component {
  state = {
    open: false,
    clockOutDialog: false,
    recordDialogOpen: false,
    record: {},
    project: {},
    loading: false,
    profilePictureRequired: false,
    clockInTargetProject: null,
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleClickClockOut = (record) => {
    this.props.openClockOutDialog(record.project.id);
    this.setState({ record: record });
  };

  closeRecordDialog = () => {
    this.setState({ record: {}, recordDialogOpen: false });
  };

  handleOnClockInFromPictureMust = () => {};

  handleOnClockIn = (project, updatedResource) => {
    this.props.clockInRecord({
      projectId: project.id,
      allowClockInWithoutLocation: false,
    });
  };

  timerButton = null;

  render() {
    const { classes, inRecords, inRecordsLoading, lastProjects } = this.props;

    const { open } = this.state;

    const timerContent = (
      <Translation ns={['common']}>
        {(t) => (
          <TimerContent onClose={this.handleClose}>
            {inRecords.map((record) => (
              <RecordItem
                key={record.id}
                record={record}
                onClickClockOut={() => this.handleClickClockOut(record)}
                onClickRecordDialog={() => this.props.openRecordDialog(record)}
                onClose={() => this.handleClose()}
              />
            ))}
            {lastProjects && lastProjects.length > 0 && (
              <div className={classes.listTitle}>
                {t('common.latest_projects')}
              </div>
            )}
            {lastProjects.map((item) => (
              <ProjectItem
                project={item}
                key={item.id}
                onClickClockIn={() => this.handleOnClockIn(item)}
                loading={this.state.loading}
                onCloseParent={this.handleClose}
              />
            ))}
          </TimerContent>
        )}
      </Translation>
    );

    const badge = inRecordsLoading ? (
      <SideBadge badgeContent={<CircularProgress color="inherit" size={12} />}>
        {/* <TimerIcon /> */}
        <Icon path={mdiTimerOutline} size={1} />
      </SideBadge>
    ) : (
      <SideBadge
        badgeContent={inRecords.length}
        color="secondary"
        invisible={inRecords.length === 0}
      >
        <Icon path={mdiTimerOutline} size={1} />
      </SideBadge>
    );

    return (
      <div className={clsx(classes.root, open && classes.rootOpen)}>
        <Hidden xsDown>
          <IconButton
            className={classes.iconButton}
            color="inherit"
            ref={(node) => {
              this.timerButton = node;
            }}
            onClick={this.handleOpen}
            title="Notifications"
          >
            {badge}
          </IconButton>
          <Drawer
            anchor="right"
            classes={{ paper: classes.drawerPaper }}
            onClose={this.handleClose}
            open={open}
          >
            {timerContent}
          </Drawer>
        </Hidden>
        <Hidden smUp>
          <IconButton
            className={classes.iconButton}
            color="inherit"
            onClick={this.handleOpen}
            title="Notifications"
          >
            {badge}
          </IconButton>
          <Dialog
            fullScreen
            open={this.state.open}
            onClose={this.handleClose}
            TransitionComponent={Transition}
          >
            {timerContent}
          </Dialog>
        </Hidden>
        {/* {this.state.clockOutDialog && (
          <ClockOutDialog
            onClose={this.handleCloseClockOutDialog}
            open={this.state.clockOutDialog}
            record={this.state.record}
          />
        )} */}
      </div>
    );
  }
}

TimerButton.defaultProps = {
  classes: {},
  data: {},
  inRecords: [],
};

TimerButton.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  inRecords: PropTypes.array.isRequired,
  inRecordsLoading: PropTypes.bool.isRequired,
  lastProjects: PropTypes.array.isRequired,
  clockInRecord: PropTypes.func.isRequired,
  openRecordDialog: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

const TimerButtonCompose = connect(
  mapStateToProps,
  mapDispatchToProps
)(TimerButton);
export default withStyles(styles, { withTheme: true })(TimerButtonCompose);
